import {createSlice} from '@reduxjs/toolkit';

import type {PayloadAction} from '@reduxjs/toolkit';
import type {AppState} from '@jobseeker/common-core/types';

export interface BotDetectionState {
  captchaShown: boolean;
  captchaSiteKey: string;
  captchaSource: string;
}

export const initialState: BotDetectionState = {
  captchaShown: false,
  captchaSiteKey: '',
  captchaSource: '',
};

const botDetectionSlice = createSlice({
  name: 'BotDetection',
  initialState,
  reducers: {
    showCaptcha: (
      state,
      action: PayloadAction<{siteKey: string; source: string}>
    ) => {
      state.captchaShown = true;
      state.captchaSiteKey = action.payload.siteKey;
      state.captchaSource = action.payload.source;
    },
    hideCaptcha: state => {
      state.captchaShown = false;
      state.captchaSiteKey = '';
      state.captchaSource = '';
    },
  },
});

export const {showCaptcha, hideCaptcha} = botDetectionSlice.actions;

export const selectBotDetection = (state: AppState) => state.botDetection;

const reducer = botDetectionSlice.reducer;
export {reducer};
